import { render } from "./MarketsScreen.vue?vue&type=template&id=60511ad7&scoped=true"
import script from "./MarketsScreen.vue?vue&type=script&lang=js"
export * from "./MarketsScreen.vue?vue&type=script&lang=js"

import "./MarketsScreen.vue?vue&type=style&index=0&id=60511ad7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60511ad7"]])

export default __exports__